//#region styled components
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { StyledProps } from '@components/atoms/Inputs/Select/index';
interface OlProps {
  'data-desc'?: string;
  align?: string;
}
export const FlexCenterSetCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SelectCombo = styled.div`
  ${FlexCenterSetCss};
  //margin: 0 10px;
  color: #555555;
  label {
    margin-right: 10px;
  }
`;
export const DropDownMenu = styled(SelectCombo)`
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  border-radius: 5px;
  position: relative;

  ol[data-is='true'] {
    margin-top: 4px;
    visibility: visible;
    z-index: 1;
    ::marker {
      display: none;
    }
  }
  ${(props: StyledProps) => props.styles};
`;
export const SelectSection = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  flex: 1;
  padding: 0 16px;
  margin: auto 0;
  height: 40px;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: #e0e0e0;

  &:hover {
    border-color: #777;
    &.open {
      border-color: #00bf00;
    }
  }

  &.open {
    border-color: #00bf00;
    ::after {
      animation: rotateArray 0.1s normal forwards linear;
      animation-iteration-count: 1;
    }
  }

  &.disabled {
    cursor: not-allowed;
    background-color: #e0e0e0;
    color: #999;
    &:hover {
      border-color: #e0e0e0;
    }
    &::after {
      border-color: #999;
    }
  }
  ::after {
    content: '';
    width: 6px;
    height: 6px;
    border-width: 2px 0 0 2px;
    border-style: solid;
    border-color: #555555;
    border-radius: 2px;
    transform: rotate(225deg);
  }

  @keyframes rotateArray {
    0% {
      transform: rotate(225deg);
    }
    100% {
      transform: rotate(45deg);
    }
  }
`;

export const OptionList = styled.ol`
  box-sizing: border-box;
  list-style: none;
  position: absolute;
  z-index: 1;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  background-color: #ffffff;
  padding: 4px;
  border: 1px solid #00bf00;
  border-radius: 5px;
  ::marker {
    display: none;
  }
`;
export const OptionOrderList = styled.li`
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: ${(props: OlProps) => props['align']};
  height: 36px;
  margin: auto 0;
  padding: 0 12px;
  border-radius: 5px;
  &::after {
    margin-left: 7px;
    padding-left: 7px;
    border-left: 1px solid #555555;
    content: '${(props: OlProps) => props['data-desc']}';
    font-weight: normal;
    line-height: 17px;
  }
  :hover {
    background: #00bf00;
    color: #ffffff;
    ::after {
      border-left: 1px solid #ffffff;
    }
  }
`;
//#endregion
